import { ReferenceRange } from "../atoms/ReferenceRange";

export interface ChartLegendProps {
  refRange: { min: number; max: number };
  refRangeString: string;
  unit: string;
}

export const ChartLegend = ({ refRange, refRangeString, unit }: ChartLegendProps) => {
  if (!refRange) return null;

  return (
    <div data-slot="chart-legend" className="flex items-center gap-1.5 mt-2">
      <div className="w-4 h-px border-t-2 border-dashed border-emerald-500 opacity-60" />
      <ReferenceRange range={refRangeString} unit={unit} className="text-[11px]" />
    </div>
  );
};
